import React, { useMemo } from 'react'
import { isBookedByMember } from './utilities'
import { ExclamationCircleIcon } from '@heroicons/react/solid'
import { Tooltip } from '@material-tailwind/react'
import { ICustomer, IOrderCustomer } from 'shopify-api-node'
import { classNames } from '../../components/Utilities'

const Name = ({ customer, hasMultipleBooking, refundedOrReturned, exceedsMemberLimit = false, className = '' }: { 
    customer?: ICustomer | IOrderCustomer, 
    hasMultipleBooking: boolean, 
    refundedOrReturned: boolean, 
    exceedsMemberLimit?: boolean,
    className?: string 
}) => {
    const isMember = useMemo(() => isBookedByMember(customer), [customer])
    
    const showWarning = useMemo(() => {
        return (isMember && (hasMultipleBooking || exceedsMemberLimit))
    }, [isMember, hasMultipleBooking, exceedsMemberLimit])

    const tooltipContent = useMemo(() => {
        if (exceedsMemberLimit) return "More than 4 member sessions booked before/after midday"
        if (hasMultipleBooking) return "Multiple member bookings in a single session"
        return ""
    }, [hasMultipleBooking, exceedsMemberLimit])

    return (
        <div className={classNames(`truncate py-0.5 flex flex-row items-center`, className)}>

            {showWarning ? (
                <Tooltip content={tooltipContent}>
                    <p className="text-red-500 font-[650] text-[16px] pr-1">
                        {customer?.first_name} {customer?.last_name}
                    </p>
                </Tooltip>
            ):(
                <p className={`${refundedOrReturned ? "line-through": ""} text-[16px]`}>
                    {customer?.first_name} {customer?.last_name}
                </p>
            )}

            {showWarning && <ExclamationCircleIcon fill="#F53B3B" width={"1rem"} className="mr-1" />}
        </div>
    )
}

export default Name